<template>
  <div class="tables-section">
    <div class="container">
      <h2>
        <slot name="title"></slot>
      </h2>
      <p>
        <slot name="text"></slot>
      </p>
      <div class="row tables justify-content-around d-none d-md-flex">
        <div
          v-for="(table, index) in tables"
          :key="index"
          class="card col-md-8 col-lg-5 px-0"
        >
          <div class="card-body">
            <span class="card-title text-center mb-0">{{ table.title }}</span>
            <div
              class="row table-row"
              v-for="(row, index) in table.rows"
              :key="index"
            >
              <div class="col-4 row-title">{{ row.title }}</div>
              <div class="col-8 row-value">{{ row.value }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="row tables tables__mobile d-md-none">
        <div
          v-for="(table, index) in tables"
          :key="index"
          class="card w-100 px-0"
        >
          <div class="card-body">
            <span class="card-title text-center mb-0 border-bottom-0">{{
              table.title
            }}</span>
            <div
              class="table-row"
              v-for="(row, index) in table.rows"
              :key="index"
            >
              <div class="col row-title text-center">{{ row.title }}</div>
              <div class="col row-value text-center">{{ row.value }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="row justify-content-center">
        <router-link to="/get-start?step=1" tag="button" class="cta">{{
          !!ctaButtonTitle ? "Get a quote" : "Get a quote"
        }}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tables: Array,
    ctaButtonTitle: String,
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding-top: 40px;
  padding-bottom: 40px;
  @media (min-width: 768px) {
    padding-top: 80px;
    padding-bottom: 80px;
    /* padding-left: 60px; */
    /* padding-right: 60px; */
  }

  border-bottom: 1px solid #ccc;

  @media (min-width: 1200px) {
    /* padding-left: 120px; */
    /* padding-right: 120px; */
  }

  p {
    color: #666;
    font-weight: 600;
  }
}

h2 {
  font-size: 30px !important;
  font-weight: 900;
  margin: 0;
  margin-bottom: 20px;
  text-align: center;
  font-family: "Biotif", "Helvetica", sans-serif;

  @media (min-width: 768px) {
    font-size: 36px !important;
  }
}

p {
  text-align: center;
}

.tables {
  margin-top: 50px;
  margin-bottom: 50px;

  @media (max-width: 767px) {
    margin-left: 0;
    margin-right: 0;
  }
}

.card {
  border-color: #ccc;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
  @media (min-width: 992px) {
    margin-bottom: 50px;
  }
  @media (max-width: 991px) {
    &:not(:last-child) {
      margin-bottom: 32px;
    }
  }
}

.card-title {
  display: block;
  font-weight: 700;
  font-size: 24px;
  border-bottom: 2px solid #222222;
  padding-bottom: 20px;
}

.tables:not(.tables__mobile) {
  .table-row {
    margin-right: 0;
    margin-left: 0;

    &:not(:last-child) {
      border-bottom: 1px solid #999;
    }
  }
  .row-title,
  .row-value {
    padding: 32px 20px;
    margin-left: 0;
    text-align: right;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    
    @media (min-width: 768px) {
      font-size: 18px;
    }
  }

  .row-title {
    border-right: 1px solid #999;
    color: #666;
    font-weight: 600;
  }

  .row-value {
    font-weight: 700;
    white-space: pre-line;
  }
}

.tables__mobile {
  .card-body {
    padding: 30px 0 10px;
  }

  .card-title {
    padding: 0px 30px 20px;
  }
  .row-title,
  .row-value {
    padding: 20px 30px;
  }

  .row-title {
    font-size: 18px;
    font-weight: 700;
    background-color: #eff9fe;
  }

  .row-value {
    font-weight: 600;
    white-space: pre-line;
  }
}
</style>



// WEBPACK FOOTER //
// TablesSection.vue?a571e2d4